var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEasytoUse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.694,
    height: 102.511,
    viewBox: "0 0 145.694 102.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256",
    transform: "translate(598.423 1130.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236",
    transform: "translate(-598.423 -1130.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    d: "M-394.412-996.489h-140.066a2.805 2.805 0 0 1-2.814-2.789v-96.932a2.805 2.805 0 0 1 2.814-2.79h140.065a2.805 2.805 0 0 1 2.814 2.79v96.932a2.805 2.805 0 0 1-2.813 2.789zm-140.065-101.116a1.4 1.4 0 0 0-1.407 1.395v96.932a1.4 1.4 0 0 0 1.407 1.395h140.065a1.4 1.4 0 0 0 1.407-1.395v-96.932a1.4 1.4 0 0 0-1.407-1.395z",
    fill: "#017cee",
    "data-name": "Path 1070",
    transform: "translate(537.292 1099)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    transform: "translate(1.015 12.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_457",
    d: "M0 0h144.287v1.407H0z",
    fill: "#017cee",
    "data-name": "Rectangle 457"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(6.319 5.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    cx: 1.671,
    cy: 1.671,
    r: 1.671,
    fill: "#017cee",
    "data-name": "Ellipse 119"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(10.696)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    cx: 1.671,
    cy: 1.671,
    r: 1.671,
    fill: "#017cee",
    "data-name": "Ellipse 120"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(5.348)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    cx: 1.671,
    cy: 1.671,
    r: 1.671,
    fill: "#017cee",
    "data-name": "Ellipse 121"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246",
    transform: "translate(-587.694 -1107.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(0 3.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    d: "M-496.266-1021.991v9.118h-9.119v-9.118h9.119m.144-1.407h-9.406a1.263 1.263 0 0 0-1.263 1.263v9.406a1.263 1.263 0 0 0 1.263 1.263h9.406a1.263 1.263 0 0 0 1.263-1.263v-9.406a1.263 1.263 0 0 0-1.263-1.263z",
    fill: "#017cee",
    "data-name": "Path 1071",
    transform: "translate(506.792 1023.398)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(0 19.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    d: "M-496.266-976.1v9.119h-9.119v-9.119h9.119m.144-1.407h-9.406a1.263 1.263 0 0 0-1.263 1.263v9.406a1.263 1.263 0 0 0 1.263 1.263h9.406a1.263 1.263 0 0 0 1.263-1.263v-9.406a1.263 1.263 0 0 0-1.263-1.263z",
    fill: "#017cee",
    "data-name": "Path 1072",
    transform: "translate(506.792 977.507)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(0 35.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    d: "M-496.266-930.209v9.119h-9.119v-9.119h9.119m.144-1.407h-9.406a1.263 1.263 0 0 0-1.263 1.263v9.406a1.263 1.263 0 0 0 1.263 1.263h9.406a1.263 1.263 0 0 0 1.263-1.263v-9.406a1.263 1.263 0 0 0-1.263-1.263z",
    fill: "#017cee",
    "data-name": "Path 1073",
    transform: "translate(506.792 931.616)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240",
    transform: "translate(0 51.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    d: "M-496.266-884.318v9.119h-9.119v-9.119h9.119m.144-1.407h-9.406a1.263 1.263 0 0 0-1.263 1.263v9.406a1.263 1.263 0 0 0 1.263 1.263h9.406a1.263 1.263 0 0 0 1.263-1.263v-9.406a1.263 1.263 0 0 0-1.263-1.263z",
    fill: "#017cee",
    "data-name": "Path 1074",
    transform: "translate(506.792 885.725)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(64.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    d: "M-264.97-1031.968v63.868h-56.85v-63.869h56.85m.144-1.407h-57.138a1.263 1.263 0 0 0-1.263 1.263v64.157a1.263 1.263 0 0 0 1.263 1.263h57.138a1.263 1.263 0 0 0 1.263-1.263v-64.157a1.263 1.263 0 0 0-1.263-1.263z",
    fill: "#017cee",
    "data-name": "Path 1075",
    transform: "translate(323.227 1033.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242",
    transform: "translate(17.898 24.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    d: "M-420.468-961.14h-34.746a.7.7 0 0 1-.7-.7.7.7 0 0 1 .7-.7h34.746a.7.7 0 0 1 .7.7.7.7 0 0 1-.7.7z",
    fill: "#017cee",
    "data-name": "Path 1076",
    transform: "translate(455.917 962.547)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(17.898 8.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    d: "M-420.468-1007.031h-34.746a.7.7 0 0 1-.7-.7.7.7 0 0 1 .7-.7h34.746a.7.7 0 0 1 .7.7.7.7 0 0 1-.7.7z",
    fill: "#017cee",
    "data-name": "Path 1077",
    transform: "translate(455.917 1008.438)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244",
    transform: "translate(17.898 41.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    d: "M-420.468-915.249h-34.746a.7.7 0 0 1-.7-.7.7.7 0 0 1 .7-.7h34.746a.7.7 0 0 1 .7.7.7.7 0 0 1-.7.7z",
    fill: "#017cee",
    "data-name": "Path 1078",
    transform: "translate(455.917 916.656)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(17.898 57.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    d: "M-420.468-869.358h-34.746a.7.7 0 0 1-.7-.7.7.7 0 0 1 .7-.7h34.746a.7.7 0 0 1 .7.7.7.7 0 0 1-.7.7z",
    fill: "#017cee",
    "data-name": "Path 1079",
    transform: "translate(455.917 870.765)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasytoUse);
export default __webpack_public_path__ + "static/media/EasytoUse.27866cd07e4b56077bf3e1a873993716.svg";
export { ForwardRef as ReactComponent };